import { render, staticRenderFns } from "./SwitchOrganisation.vue?vue&type=template&id=69a168e8&scoped=true"
import script from "./SwitchOrganisation.vue?vue&type=script&lang=js"
export * from "./SwitchOrganisation.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrganisation.vue?vue&type=style&index=0&id=69a168e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a168e8",
  null
  
)

export default component.exports